import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { scopeForPath, useSiteStore } from '@stores/siteStore'
import Header from './Header'
import Sidebar from './Sidebar'

export default function Layout() {
  const location = useLocation()
  const scope = useSiteStore((s) => s.scope)
  const setScope = useSiteStore((s) => s.setScope)

  useEffect(() => {
    const routeScope = scopeForPath(location.pathname)
    if (routeScope && routeScope !== scope) setScope(routeScope)
  }, [location.pathname, scope, setScope])

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-950">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
